import * as agreementActions from '@bca-agreement/store/agreement.actions';
import { AgreementActionTypes } from '@bca-agreement/store/agreement.actions';
import { IAgreement } from '@bca-shared/models/agreement';
import { IIssuer } from '@bca-agreement/models/issuer';
import { PaymentPeriod } from '@bca-agreement/models/_enums';

export const INITIAL_STATE: IState = {
  issuers: null,
  selectedAgreement: {
    paymentPeriod: PaymentPeriod.MONTHLY, authorizedAgreementAndProductConditions: null,
    authorizedDirectDebit: null,
    authorizedVerifyInfo: null,
    issuer: null},
  agreementPreviewAsBase64: null,
  agreementPreviewLoading: false
};

export interface IState {
  readonly issuers: IIssuer[];
  readonly selectedAgreement: IAgreement;
  readonly agreementPreviewAsBase64: string;
  readonly agreementPreviewLoading: boolean;
}

export function reducer(state: IState = INITIAL_STATE, action: agreementActions.Action): IState {
  switch (action.type) {
    case AgreementActionTypes.SelectAgreement: {
      const selectedAgreement = action.payload;
      return {
        ...state,
        selectedAgreement
      };
    }
    case AgreementActionTypes.SetIssuers: {
      const issuers = action.payload;
      return {
        ...state,
        issuers
      };
    }
    case AgreementActionTypes.SetAgreementPreview: {
      const { agreementPreviewAsBase64 } = action.payload;
      return {
        ...state,
        agreementPreviewAsBase64
      };
    }
    case AgreementActionTypes.AgreementPreviewLoading: {
      const { loading: agreementPreviewLoading } = action.payload;
      return {
        ...state,
        agreementPreviewLoading
      };
    }
  }

  return state;
}
